// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?ver=" + "8f90fdc54c15b69779bf" + "";
};